// const longMonthNames = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// const shortMonthNames = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// export const getMonthYear = (date) => {
//   if (date === undefined) {
//     return date;
//   }

//   var dt = parseDate(date);
//   if (!dt || isNaN(dt.getTime())) {
//     return '';
//   }
//   return dt.toLocaleString("en-us", {
//     month: "short",
//     year: "numeric",
//   });
// };

// export const parseDateTime = (dt) => {
//   const [dateRelated, timeRelated] = dt.includes(",")
//     ? dt.split(", ")
//     : dt.split(" ");
//   const [day, month, year] = dateRelated.split("/");
//   const [hours, minutes, seconds] = timeRelated.split(":");
//   const date = new Date(year, month - 1, +day, +hours, +minutes, +seconds);
//   return date;
// };

// export const getMessageTS = (dt) => {
//   if (dt === undefined) {
//     return dt;
//   }
//   const date = parseDateTime(dt);
//   if (!date || isNaN(date.getTime())) {
//     return '';
//   }
//   const hours = date.getHours();
//   const minutes = date.getMinutes();
//   const month = date.getUTCMonth();
//   const short_year = date.getFullYear() % 100;
//   const hour = hours > 12 ? hours - 12 : hours;
//   const am_pm = hours > 12 ? "PM" : "AM";
//   const hour_formatted = String(hour).length === 1 ? `0${hour}` : `${hour}`;
//   const min_formatted =
//     String(minutes).length === 1 ? `0${minutes}` : `${minutes}`;

//   return `${hour_formatted}:${min_formatted} ${am_pm} ${shortMonthNames[month]} ${short_year}`;
// };

// // This function calculates the number of days, hours, minutes, weeks and months between a given date and today
// export const daysBetween = (utcTimestamp) => {
//   // Convert the UTC timestamp to a local date object
//   const date = parseDate(utcTimestamp);
//   if (!date || isNaN(date.getTime())) {
//     return null;
//   }
//   const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

//   // Return null if no date is provided
//   if (!localDate) {
//     return null;
//   }

//   // Calculate time difference between the input date and now
//   const now = new Date();
//   const timeDiff = Math.abs(now.getTime() - localDate.getTime());

//   // Calculate days, hours, and minutes from the time difference
//   const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
//   const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
//   const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);

//   // Calculate weeks and months from the number of days
//   const weeks = Math.floor(days / 7);
//   const months = Math.floor(days / (4 * 7));

//   // Return a string that indicates how long ago or how far in the future the date is
//   if (months === 1) {
//     return "1 month ago";
//   } else if (months > 1) {
//     return `${months} months ago`;
//   } else if (weeks === 1) {
//     return "1 week ago";
//   } else if (weeks > 1) {
//     return `${weeks} weeks ago`;
//   } else if (days === 1) {
//     return "1 day ago";
//   } else if (days === 0) {
//     if (hours === 0 && minutes === 0) {
//       return "Just now";
//     } else if (hours === 0 && minutes < 60) {
//       return "1 hour ago";
//     } else if (hours === 0) {
//       return `${minutes} minutes ago`;
//     } else {
//       return `${hours} hours ago`;
//     }
//   } else if (days === -1) {
//     return "Tomorrow";
//   } else if (days === -2) {
//     return "Day after tomorrow";
//   } else if (days < -2) {
//     return `${Math.abs(days)} days later`;
//   } else {
//     return `${days} days ago`;
//   }
// };

// // Convert UTC date to local time using a simpler approach
// export const parseDate = (dateString) => {
//   if (!dateString) return null;

//   try {
//     // For ISO strings, create a local date by treating the UTC time as local
//     if (typeof dateString === 'string' && dateString.includes('T')) {
//       // Remove any existing timezone indicators
//       const cleanString = dateString.replace(/[Z+\-]\d{2}:?\d{0,2}$/, '');

//       // Parse components manually
//       const [datePart, timePart] = cleanString.split('T');
//       const [year, month, day] = datePart.split('-').map(Number);
//       const [hour, minute, second] = (timePart || '00:00:00').split(':').map(Number);

//       // Create a local date by treating the UTC components as local time
//       // This effectively shifts the time to local timezone
//       const localDate = new Date(year, month - 1, day, hour, minute, second || 0);
//       return localDate;
//     }

//     // For other formats, try standard parsing
//     const date = new Date(dateString);
//     if (!isNaN(date.getTime())) {
//       return date;
//     }

//     // Final fallback
//     return new Date();
//   } catch (error) {
//     console.warn('Date parsing failed for:', dateString, error);
//     return new Date();
//   }
// };

// // Convert UTC date string to proper local time for display
// export const parseLocalDate = (dateString) => {
//   if (!dateString) return null;

//   try {
//     // Ensure the date string is treated as UTC by adding Z if needed
//     let utcString = dateString;
//     if (dateString.includes('T') && !dateString.endsWith('Z') && !dateString.includes('+')) {
//       utcString = dateString + 'Z';
//     }

//     // Parse as UTC date
//     const utcDate = new Date(utcString);

//     if (isNaN(utcDate.getTime())) {
//       console.warn('Could not parse date:', dateString);
//       return new Date(); // Return current date as fallback
//     }

//     // Return the UTC date - formatDistanceToNow will automatically display it in local time
//     return utcDate;

//   } catch (error) {
//     console.warn('Local date parsing failed for:', dateString, error);
//     return new Date(); // Return current date as fallback
//   }
// };

// export const extractDateFromDateTime = (datetimeString) => {
//   const datetime = parseDate(datetimeString);
//   if (!datetime || isNaN(datetime.getTime())) {
//     return '';
//   }
//   const year = datetime.getFullYear();
//   const month = datetime.getMonth() + 1;
//   const day = datetime.getDate();
//   return `${year}-${month < 10 ? "0" + month : month}-${
//     day < 10 ? "0" + day : day
//   }`;
// };

const longMonthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const shortMonthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * Parse a UTC-like string (e.g., "2025-08-17T18:00:00") as UTC and return a Date.
 * No "Z" is appended. We manually parse components and use Date.UTC to get the instant.
 * If the string already has an explicit offset or Z, we let the native parser handle it.
 */
export function parseUtcStringToLocalDate(dateString) {
  if (!dateString) return null;

  try {
    // If an explicit offset/Z exists, trust the native parser.
    if (/[zZ]|[+\-]\d{2}:?\d{2}$/.test(dateString)) {
      const d = new Date(dateString);
      return isNaN(d.getTime()) ? null : d;
    }

    // Expected ISO-like without zone: "YYYY-MM-DDTHH:mm:ss" (time optional)
    // (Works if you pass "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm")
    if (dateString.includes("T")) {
      const [datePart, timePart = "00:00:00"] = dateString.split("T");
      const [y, m, d] = datePart.split("-").map(Number);

      // Handle hh:mm or hh:mm:ss (and optional .SSS)
      const rawTime = timePart.split(".")[0]; // drop fractional seconds
      const [hh = 0, mm = 0, ss = 0] = rawTime.split(":").map(Number);

      // Treat parsed parts as UTC components → instant in time
      const ms = Date.UTC(y, (m || 1) - 1, d || 1, hh, mm, ss);
      return new Date(ms); // this Date renders in LOCAL time in getters/toLocale*
    }

    // Fallback: native parse (covers dd/mm/yyyy hh:mm:ss paths if needed)
    const d = new Date(dateString);
    return isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

export const getMonthYear = (date) => {
  if (!date) return date;
  const dt = parseUtcStringToLocalDate(date);
  if (!dt || isNaN(dt.getTime())) return "";
  return dt.toLocaleString("en-US", { month: "short", year: "numeric" });
};

/** Parses "dd/mm/yyyy, hh:mm:ss" or "dd/mm/yyyy hh:mm:ss" already in LOCAL time */
export const parseDateTime = (dt) => {
  if (!dt) return null;
  const [dateRelated, timeRelated] = dt.includes(",")
    ? dt.split(", ")
    : dt.split(" ");
  const [day, month, year] = dateRelated.split("/").map(Number);
  const [hours = 0, minutes = 0, seconds = 0] = (timeRelated || "00:00:00")
    .split(":")
    .map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds);
};

export const getMessageTS = (dt) => {
  if (!dt) return dt;
  const date = parseDateTime(dt);
  if (!date || isNaN(date.getTime())) return "";

  const hours24 = date.getHours();
  const minutes = date.getMinutes();
  const month = date.getMonth();
  const shortYear = date.getFullYear() % 100;
  const hour12 = hours24 % 12 || 12;
  const ampm = hours24 >= 12 ? "PM" : "AM";
  const hh = hour12 < 10 ? `0${hour12}` : `${hour12}`;
  const mm = minutes < 10 ? `0${minutes}` : `${minutes}`;

  return `${hh}:${mm} ${ampm} ${shortMonthNames[month]} ${shortYear}`;
};

/** Humanized distance from now; input is UTC-like string */
export const daysBetween = (utcTimestamp) => {
  const date = parseUtcStringToLocalDate(utcTimestamp);
  if (!date || isNaN(date.getTime())) return null;

  const now = new Date();
  const diff = Math.abs(now.getTime() - date.getTime());

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff / 3600000) % 24);
  const minutes = Math.floor((diff / 60000) % 60);

  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);

  if (months === 1) return "1 month ago";
  if (months > 1) return `${months} months ago`;
  if (weeks === 1) return "1 week ago";
  if (weeks > 1) return `${weeks} weeks ago`;
  if (days === 1) return "1 day ago";
  if (days === 0) {
    if (hours === 0 && minutes === 0) return "Just now";
    if (hours === 0) return `${minutes} minutes ago`;
    return `${hours} hours ago`;
  }
  return `${days} days ago`;
};

/** Backwards-compatible alias used elsewhere in your code */
export function parseDate(dateString) {
  if (!dateString) return null;

  try {
    // Handle format like "2025-08-18 03:59:24.162437"
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(dateString)) {
      const [datePart, timePartRaw] = dateString.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);

      // remove fractional seconds if present
      const timePart = timePartRaw.split(".")[0];
      const [hh = 0, mm = 0, ss = 0] = timePart.split(":").map(Number);

      // Treat as UTC
      const utcMillis = Date.UTC(year, month - 1, day, hh, mm, ss);
      return new Date(utcMillis);
    }

    // Handle ISO strings with "T"
    if (dateString.includes("T")) {
      return new Date(dateString); // native parser handles with/without Z
    }

    // Fallback
    const d = new Date(dateString);
    return isNaN(d.getTime()) ? null : d;
  } catch {
    return null;
  }
}

/** YYYY-MM-DD extracted from local rendering of a UTC instant */
export const extractDateFromDateTime = (datetimeString) => {
  const dt = parseUtcStringToLocalDate(datetimeString);
  if (!dt || isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = dt.getMonth() + 1;
  const d = dt.getDate();
  return `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
};
